import { registerBlock, registerRelationship } from "../../registry";
import { makeId } from "../../helpers";
import type { ContentBlock } from "../../types";

const iuiCycle: ContentBlock<"program"> = {
  id: makeId("program-iui-cycle"),
  kind: "program",
  tags: ["iui", "both-partners", "treatment"],
  title: "IUI Cycle",
  subtitle: "Medicated or natural IUI with monitoring and TWW support",
  icon: "💧",
  body: {
    duration: "1–2 months",
    includes: [
      "Fertility baseline for her",
      "Ovulation monitoring with ultrasound",
      "Trigger shot timing (if medicated cycle)",
      "Sperm wash and intrauterine insemination",
      "Two-week wait support and beta-hCG testing",
    ],
    priceRange: { low: 800, high: 2000 },
    currency: "USD",
    status: "coming-soon",
    forWhom: "both",
    category: "treatment",
    moduleIds: [
      makeId("module-female-hormone-baseline"),
      makeId("module-iui-procedure"),
      makeId("module-tww-support"),
    ],
    phases: [
      {
        title: "Assessment",
        description: "Confirm ovarian function and timing",
        moduleIds: [makeId("module-female-hormone-baseline")],
      },
      {
        title: "Insemination",
        description: "Monitoring, trigger, and IUI procedure",
        moduleIds: [makeId("module-iui-procedure")],
      },
      {
        title: "Two-Week Wait",
        description: "Support through the waiting period",
        moduleIds: [makeId("module-tww-support")],
      },
    ],
    steps: [
      {
        title: "Baseline & monitoring",
        description:
          "Confirm ovulation timing with ultrasound. Start medications if prescribed.",
      },
      {
        title: "IUI procedure",
        description: "Sperm wash and insemination. Quick, in-office procedure.",
      },
      {
        title: "Wait & test",
        description: "Two-week wait with support. Beta-hCG test at 14 days.",
      },
    ],
  },
  sources: [
    {
      title: "Intrauterine insemination: evidence-based guidelines",
      journal: "Human Reproduction Update",
      year: 2021,
      evidenceLevel: "meta-analysis",
    },
  ],
};

registerBlock(iuiCycle);

const id = makeId("program-iui-cycle");
registerRelationship({
  from: id,
  to: makeId("module-female-hormone-baseline"),
  type: "contains",
});
registerRelationship({
  from: id,
  to: makeId("module-iui-procedure"),
  type: "contains",
});
registerRelationship({
  from: id,
  to: makeId("module-tww-support"),
  type: "contains",
});
